import React from 'react';

import ContactForm from '../../components/contact-form/contact-form.component';

import { ContactContainer } from './contact.styles';

const ContactPage = () => (
  <ContactContainer>
    <ContactForm />
  </ContactContainer>
);

export default ContactPage;
